import { useEffect, useState } from "react";
import { colors } from "constants/colors";
import styled from "styled-components";
import { StyledText } from "styles/Text";

export interface DropdownOption {
  value: string | number;
  label: string;
  labelColor?: string; // 글자 색상
}

interface Props {
  isOpen?: boolean;
  onChangeValue?: (e: number | string) => void;
  options: DropdownOption[];
  selectedValue?: string | number;
}

const Dropdown = ({ isOpen, onChangeValue, options, selectedValue }: Props) => {
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [, setSelectOption] = useState<DropdownOption>({
    label: "",
    value: "",
  });

  useEffect(() => {
    const findSelectedIndex = options.findIndex(
      ({ value }) => value === selectedValue,
    );
    setSelectedIndex(findSelectedIndex);

    // 선택된 값이 있음
    if (findSelectedIndex >= 0) {
      const findSelectOption = options.find(
        ({ value }) => value === selectedValue,
      );

      if (findSelectOption) {
        setSelectOption(findSelectOption);
      }
    } else {
      setSelectOption({ label: "없음", value: "" });
    }
  }, [options, selectedValue]);

  useEffect(() => {
    if (isOpen) {
      setIsShowDropdown(true);
    } else {
      setIsShowDropdown(false);
    }
  }, [isOpen]);

  if (!isShowDropdown) {
    return <></>;
  }
  return (
    <StyledDropdownBox>
      {options.map((item, index) => (
        <StyledDropdownItem
          key={"item_" + index}
          value={item.value}
          onClick={(e) => {
            setIsShowDropdown(false);
            onChangeValue && onChangeValue(e.currentTarget.value);
          }}
          selected={index === selectedIndex}
        >
          <StyledText.Body13
            color={index === selectedIndex ? colors.mainOrange : colors.black}
          >
            {item.label}
          </StyledText.Body13>
          {index === selectedIndex && (
            <StyledSelectImg
              src={require("assets/images/ic_check_normal_outlined_orange_s.png")}
            />
          )}
        </StyledDropdownItem>
      ))}
    </StyledDropdownBox>
  );
};

export default Dropdown;

const StyledDropdownBox = styled.div`
  border-radius: 12px;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray1};
  padding: 8px 0px;
  position: absolute;
  top: 50px;
  right: 0;
  display: flex;
  flex-direction: column;
`;

const StyledDropdownItem = styled.button<{ selected?: boolean }>`
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: ${(props) => (props.selected ? "16px" : "40px")};
  text-align: start;
  white-space: nowrap;
  color: ${(props) => (props.selected ? colors.mainOrange : colors.black)};
`;

const StyledSelectImg = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 4px;
  vertical-align: middle;
`;
